import React from 'react';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Payout } from '@api/types/commissions';
import DrawerComponent from '../../../../../../components/Drawer/Drawer';
import PayoutOverview from './PayoutOverview';
import FinalCommission from './FinalCommission';
import PaymentStatus from './PaymentStatus';

interface PayoutStatusProps {
  showPayoutStatus: boolean;
  setShowPayoutStatus: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRowData: Payout | null;
  handlePayoutStatusChange: () => void;
}

const PayoutStatus: React.FC<PayoutStatusProps> = ({
  showPayoutStatus,
  setShowPayoutStatus,
  selectedRowData,
  handlePayoutStatusChange,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <DrawerComponent
      open={showPayoutStatus}
      anchor="right"
      close={() => {
        setShowPayoutStatus(false);
      }}
      height="98vh"
      zIndex={9999}
      backgroundColor="#F0F0F1"
    >
      <Box
        sx={{
          padding: '1.5rem',
          width: isMobile ? 'auto' : '600px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: '1.375rem',
            fontWeight: 700,
            lineHeight: '1.875rem',
            color: '#6C6C6C',
          }}
        >
          Payout Status
          <Button
            sx={{ padding: 0, minWidth: 'fit-content' }}
            onClick={() => {
              setShowPayoutStatus(false);
            }}
          >
            <CloseIcon sx={{ color: '#162C36' }} />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          margin: '1rem 1.5rem',
          width: isMobile ? 'auto' : '552px',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        {/* Content will be added here */}
        {selectedRowData && (
          <PayoutOverview
            referrer={selectedRowData.referrerName}
            payoutMonth={selectedRowData.payoutMonth}
            commission={selectedRowData.commission}
          />
        )}

        <FinalCommission id={selectedRowData?.paymentId} />

        {selectedRowData && (
          <PaymentStatus
            paymentId={selectedRowData.paymentId}
            paymentStatus={selectedRowData.paymentStatus}
            paymentDate={selectedRowData.payoutDate ?? undefined}
            transactionId={selectedRowData.transactionId ?? undefined}
            description={selectedRowData.description ?? undefined}
            handlePayoutStatusChange={handlePayoutStatusChange}
            approvedDate={selectedRowData.approvedDate ?? undefined}
          />
        )}
      </Box>
    </DrawerComponent>
  );
};

export default PayoutStatus;
